// 상세 화면에서 값이 비어 있을 때 "null"이나 빈칸이 그대로 노출되지 않도록
// 도와주는 함수들입니다.

// 값이 실제로 들어있는지 확인합니다.
// 데이터베이스에서 넘어온 null, undefined, 빈 문자열, 문자열 "null"을 모두 걸러냅니다.
export const hasValue = (value) =>
  value !== null &&
  value !== undefined &&
  value !== "" &&
  value !== "null" &&
  value !== "undefined";

// 켜고 끄는 항목이 실제로 선택됐는지 확인합니다.
// 이런 항목은 데이터베이스에 참/거짓이 아니라 글자로 저장되는데,
// 자바스크립트에서는 "false"라는 글자도 "값이 있다"로 취급하기 때문에
// 그냥 조건문에 넣으면 선택하지 않은 항목까지 선택한 것으로 나옵니다.
export const isChecked = (value) =>
  hasValue(value) && value !== "false" && value !== "0" && value !== false;

// 값이 없으면 대시(-)를 보여줍니다.
export const orDash = (value) => (hasValue(value) ? value : "-");

// "2020년 3월" 처럼 여러 조각을 합치되, 하나라도 비어 있으면 대시를 돌려줍니다.
// parts 예시: [[year, "년"], [month, "월"]]
export const joinParts = (parts) => {
  if (parts.some(([value]) => !hasValue(value))) return "-";
  return parts.map(([value, unit]) => `${value}${unit}`).join(" ");
};

// 시:분 형태로 만듭니다. 비어 있으면 대시를 돌려줍니다.
export const formatTime = (hour, minute) => {
  if (!hasValue(hour) && !hasValue(minute)) return "-";
  const h = hasValue(hour) ? String(hour).padStart(2, "0") : "00";
  const m = hasValue(minute) ? String(minute).padStart(2, "0") : "00";
  return `${h}:${m}`;
};

// 금액을 1,500,000원 형태로 만듭니다. 비어 있으면 대시를 돌려줍니다.
export const formatMoney = (value) => {
  if (!hasValue(value)) return "-";
  const numbers = String(value).replace(/[^0-9]/g, "");
  if (!numbers) return "-";
  return `${Number(numbers).toLocaleString("ko-KR")}원`;
};

// "09:00 ~ 18:00" 같은 범위를 만듭니다.
// 양쪽 다 비어 있으면 "- ~ -" 대신 대시 하나만 돌려줍니다.
export const timeRange = (h1, m1, h2, m2) => {
  const hasStart = hasValue(h1) || hasValue(m1);
  const hasEnd = hasValue(h2) || hasValue(m2);
  if (!hasStart && !hasEnd) return "-";
  return `${formatTime(h1, m1)} ~ ${formatTime(h2, m2)}`;
};

// "1,000,000원 ~ 2,000,000원" 같은 범위를 만듭니다.
// 양쪽 다 비어 있으면 대시 하나만 돌려줍니다.
export const moneyRange = (min, max) => {
  if (!hasValue(min) && !hasValue(max)) return "-";
  return `${formatMoney(min)} ~ ${formatMoney(max)}`;
};
